const angular = require('angular');
const app = angular.module('learn-directives');
var tuiImageEditorImport = require('../../imports/tui-image-editor');

/**
 * Defines the add Images component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('singleImageEditor', ['Application', 'S3Uploads', 'Upload', function (Application, S3Uploads, Upload) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        link: '=',
        onChange: '&?'
      },
      template: require('../../../templates/directives/cms/single-image-editor.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.modifiedLink = '';
        self.modifiedId = 'single-modify';
        self.brandColor = Application.colors.get().slice(0, 1);
        self.savingExisting = false;

        // black theme 
        var blackTheme = {
          'common.bi.image': 'https://uicdn.toast.com/toastui/img/tui-image-editor-bi.png',
          'common.bisize.width': '251px',
          'common.bisize.height': '21px',
          'common.backgroundImage': Application.tuiBgImage,
          'common.backgroundColor': '#fff',
          'common.border': '1px solid #c1c1c1',
      
          // header
          'header.backgroundImage': 'none',
          'header.backgroundColor': 'transparent',
          'header.border': '0px',
      
          // load button
          'loadButton.backgroundColor': '#fff',
          'loadButton.border': '1px solid #ddd',
          'loadButton.color': '#222',
          'loadButton.fontFamily': '\'Inter UI\', sans-serif',
          'loadButton.fontSize': '12px',
      
          // download button
          'downloadButton.backgroundColor': '#fdba3b',
          'downloadButton.border': '1px solid #fdba3b',
          'downloadButton.color': '#fff',
          'downloadButton.fontFamily': '\'Inter UI\',, sans-serif',
          'downloadButton.fontSize': '12px',
      
          // main icons
          'menu.normalIcon.path': 'icon-d.svg',
          'menu.normalIcon.name': 'icon-d',
          'menu.activeIcon.path': 'icon-b.svg',
          'menu.activeIcon.name': 'icon-b',
          'menu.disabledIcon.path': 'icon-a.svg',
          'menu.disabledIcon.name': 'icon-a',
          'menu.hoverIcon.path': 'icon-c.svg',
          'menu.hoverIcon.name': 'icon-c',
          'menu.iconSize.width': '24px',
          'menu.iconSize.height': '24px',
      
          // submenu primary color
          'submenu.backgroundColor': 'transparent',
          'submenu.partition.color': '#e5e5e5',
      
          // submenu icons
          'submenu.normalIcon.path': 'icon-d.svg',
          'submenu.normalIcon.name': 'icon-d',
          'submenu.activeIcon.path': 'icon-b.svg',
          'submenu.activeIcon.name': 'icon-b',
          'submenu.iconSize.width': '32px',
          'submenu.iconSize.height': '32px',
      
          // submenu labels
          'submenu.normalLabel.color': '#858585',
          'submenu.normalLabel.fontWeight': 'normal',
          'submenu.activeLabel.color': '#000000',
          'submenu.activeLabel.fontWeight': 'normal',
      
          // checkbox style
          'checkbox.border': '1px solid #ccc',
          'checkbox.backgroundColor': '#fff',
      
          // rango style
          'range.pointer.color': self.brandColor,
          'range.bar.color': '#858585',
          'range.subbar.color': self.brandColor,
      
          'range.disabledPointer.color': '#d3d3d3',
          'range.disabledBar.color': 'rgba(85,85,85,0.06)',
          'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',
      
          'range.value.color': '#858585',
          'range.value.fontWeight': 'normal',
          'range.value.fontSize': '11px',
          'range.value.border': '0',
          'range.value.backgroundColor': '#858585',
          'range.title.color': '#858585',
          'range.title.fontWeight': 'lighter',
      
          // colorpicker style
          'colorpicker.button.border': '0px',
          'colorpicker.title.color': '#858585'
        };

        self.initialize = function() {
          self.state = 'new';

          if ($scope.link) {
            self.state = 'edit';
          }
        };

        self.setImage = function(image) {
          $scope.link = image;
          setTimeout(function() {
            $scope.onChange();
          }, 50);
        };

        self.getFileExtension = function(filename){
          var patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
          var fileExtension = (filename).match(patternFileExtension);
          return fileExtension[1];
        };

        self.makeProgress = function(percent) {
          return {
            'width': percent + '%'
          };
        };

        self.getBackground = function () {
          if (!$scope.link) {
            return;
          }

          return {
            'background-image': 'url(' + $scope.link + ')'
          };
        };

        self.editInit = async function(imageUrl, type) {
          const tuiImageEditorModule = await tuiImageEditorImport.importModule();
          const ImageEditor = tuiImageEditorModule.default;

          self.editType = type;
          self.imageContainer = document.querySelector('#single-editor');
          self.imageMaxWidth = self.imageContainer.clientWidth - 36;
          self.imageMaxHeight = self.imageContainer.clientHeight - 36;
          self.editInstance = new ImageEditor(self.imageContainer,{
            usageStatistics: false,
            includeUI: {
              loadImage: {
                path: imageUrl,
                name: 'SampleImage'
              },
              menu: ['filter', 'crop', 'flip', 'rotate'],
              theme: blackTheme,
              menuBarPosition: 'bottom'
            },
            cssMaxWidth: self.imageMaxWidth,
            cssMaxHeight: (document.documentElement.clientHeight - 200 ),
            selectionStyle: {
              borderColor: 'white',
              cornerColor: self.brandColor,
              cornerSize: 40,
              rotatingPointOffset: 100,
              transparentCorners: false
            }
          });

          window.onresize = function() {
            self.editInstance.ui.resizeEditor();
          };

          setTimeout(function() {
            document.querySelector('.tui-image-editor-header').style.display = 'none';
            self.editInstance.cssMaxHeight = self.imageMaxHeight;
          }, 5);
        };

        self.replace = function() {
          document.querySelector('#single-upload').click();
        };

        self.editorSave = function() {
          self.savingExisting = true;
          function dataURItoBlob(dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for(var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
          }

          var imgData = self.editInstance.toDataURL({format: 'jpeg'});

          try {
            var file = new File([dataURItoBlob(imgData)], 'uploaded-img.jpeg');
          } catch(e) {
            var blob = dataURItoBlob(imgData);
            blob.name = "uploaded-img.jpeg";
            blob.lastModifiedDate = new Date();
            var file = blob;
          }

          self.loading = true;
          self.percent = 0;

          self.showEditor = false;
          S3Uploads.imagePolicy({fileName: file.name, contentType: file.type}, function(data) {
            var cloudFrontLink = data.CloudFrontLink;
            Upload.upload({
              url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
              headers: {'Remove-auth': 'yes'},
              method: 'POST',
              data: {
                key: data.Key,
                'Content-Type': data.ContentType,
                AWSAccessKeyId: data.AWSAccessKeyId,
                'success_action_status': '201',
                policy: data.S3Policy,
                signature: data.S3Signature
              },
              file: file
            }).progress(function(evt) {
              var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
              self.percentUpload = percent;
            }).success(function(data) {
              var link = cloudFrontLink;
              if (!link) {
                return;
              }
              self.setImage(link);
              self.loading = false;
              self.editorCancel();
              Application.scrollTop();
              self.savingExisting = false;
            }).catch(function(error) {
              console.log('upload error', error);
            });
          }, function(error) {
            console.log('s3url error', error);
            Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
          });
        };

        self.saveWithoutEditor = function(url){
          if (!url) {
            self.loading = false;
            self.editorCancel();
            Application.scrollTop();
            self.savingExisting = false;
            return;
          }
          self.savingExisting = true;
          self.loading = true;
          self.setImage(url);
          self.loading = false;
          self.editorCancel();
          Application.scrollTop();
          self.savingExisting = false;
        };

        self.editorCancel = function() {
          self.showEditor = false;
          self.editInstance = null;
        };

        self.removeImage = function() {
          $scope.link = '';
          setTimeout(function() {
            self.imageLink = '';
            $scope.onChange();
            $scope.$apply();
          }, 0);
        }

        self.editImage = function(type) {
          // Set timeouts are required to trick the watch
          self.imageLink = '';
          setTimeout(function() {
            self.imageLink = $scope.link;
            $scope.$apply();
          }, 0);
        };

        // Watches the value passed to the banner Upload
        $scope.$watch('img.imageLink', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          if (self.getFileExtension(newVal) !== 'gif'){
            self.showEditor = true;
            self.canEdit = true;
            setTimeout(function() {
              self.editInit(newVal, self.getFileExtension(newVal));
            }, 5);
          } else {
            self.canEdit = false;
            self.saveWithoutEditor(newVal);
          }
        });

        self.initialize();
        if ($scope.link) {
          return;
        }

        setTimeout(function() {
          document.getElementById('single-image-upload').click();
          $scope.$apply();
        }, 100);

        var contentWatch = $scope.$watch('content', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }

          self.initialize();
          contentWatch();
        });
      }],
      controllerAs: 'img'
    };
  }]);
